import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCloseCircleFill';
/** Renders an SVG icon. */
const SvgCloseCircleFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14M11.06 8.94a1.5 1.5 0 0 0-2.12 2.12L13.878 16l-4.94 4.94a1.5 1.5 0 0 0 2.122 2.12L16 18.122l4.94 4.94a1.5 1.5 0 0 0 2.12-2.122L18.122 16l4.94-4.94a1.5 1.5 0 0 0-2.122-2.12L16 13.878l-4.94-4.94Z"
      />
    </svg>
  );
};
SvgCloseCircleFill.displayName = displayName;
export default SvgCloseCircleFill;
